import { useEffect, useState } from 'react';

// A faint keyboard under the editor that lights up whatever you press.
const ROWS = [
    ['esc', '1', '2', '3', '4', '5', '6', '7', '8', '9', '0', '-', '=', '⌫'],
    ['q', 'w', 'e', 'r', 't', 'y', 'u', 'i', 'o', 'p', '[', ']', '\\'],
    ['a', 's', 'd', 'f', 'g', 'h', 'j', 'k', 'l', ';', "'", '↵'],
    ['⇧', 'z', 'x', 'c', 'v', 'b', 'n', 'm', ',', '.', '/', '↑'],
];

const ALIAS = { escape: 'esc', backspace: '⌫', enter: '↵', shift: '⇧', arrowup: '↑', ':': ';', G: 'g' };

function keyName(e) {
    const k = e.key.length === 1 ? e.key : e.key.toLowerCase();
    return ALIAS[k] || k.toLowerCase();
}

export default function Keys() {
    const [down, setDown] = useState(() => new Set());

    useEffect(() => {
        const timers = new Map();
        const press = (e) => {
            const k = keyName(e);
            setDown((prev) => new Set(prev).add(k));
            if (e.shiftKey) setDown((prev) => new Set(prev).add('⇧'));
            clearTimeout(timers.get(k));
            timers.set(
                k,
                setTimeout(() => setDown((prev) => {
                    const next = new Set(prev);
                    next.delete(k);
                    next.delete('⇧');
                    return next;
                }), 260)
            );
        };
        window.addEventListener('keydown', press);
        return () => {
            window.removeEventListener('keydown', press);
            timers.forEach(clearTimeout);
        };
    }, []);

    return (
        <div className="keys" aria-hidden="true">
            {ROWS.map((row, r) => (
                <p key={r} className="keys-row" style={{ '--indent': r }}>
                    {row.map((k) => (
                        <span key={k} className={`key ${down.has(k) ? 'is-down' : ''} ${'jkg;'.includes(k) && k.length === 1 ? 'is-hint' : ''}`}>
                            {k}
                        </span>
                    ))}
                </p>
            ))}
        </div>
    );
}
